/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-irregular-whitespace */
import {Container, Box, Text, UnorderedList, ListItem} from '@chakra-ui/react';

import {PageLayout} from '../components/global/page-layout';
import {useUserQuery} from '../graphql/generated';

const PrivacyPolicy: React.FC = () => {
  const userQuery = useUserQuery();

  return (
    <PageLayout
      firstName={userQuery.data?.user?.firstName}
      title="Terms and Conditions | Showpiece"
    >
      <Box
        textStyle={{base: 'h4', md: 'h2'}}
        as="h2"
        textAlign="center"
        mb="50px"
        mt={{base: '30px', md: '60px'}}
        color="darkGrey"
        mx={{base: '5px', md: '0px'}}
      >
        Terms and Conditions
      </Box>
      <Container maxW="container.lg">
        <Box>
          <Box mt={20}>
            <Text textStyle="h5">1. AGREEMENT TO TERMS</Text>
            <Text mt={4}>
              These Terms of Use constitute a legally binding agreement made
              between you, whether personally or on behalf of an entity (“you”)
              and Showpiece Technologies Limited, doing business
              as Showpiece ("Showpiece", “we”, “us”, or “our”), concerning your
              access to and use of the{' '}
              <a
                style={{color: 'blue', textDecoration: 'underline'}}
                href="http://www.showpiece.com"
                target="_blank"
                rel="noreferrer"
              >
                http://www.showpiece.com
              </a>
               website as well as any other media form, media channel, mobile
              website or mobile application related, linked, or otherwise
              connected thereto (collectively, the “Site”). We are registered
              in England and have our registered office at 64-66 Glentham
              Road, Barnes, London SW13 9JJ. You agree that by accessing the
              Site, you have read, understood, and agreed to be bound by all of
              these Terms of Use. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF
              USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU
              MUST DISCONTINUE USE IMMEDIATELY.
            </Text>
            <Text mt={4}>
              Supplemental terms and conditions or documents that may be posted
              on the Site from time to time are hereby expressly incorporated
              herein by reference. We reserve the right, in our sole discretion,
              to make changes or modifications to these Terms of Use from time
              to time. We will alert you about any changes by updating the “Last
              updated” date of these Terms of Use, and you waive any right to
              receive specific notice of each such change. Please ensure that
              you check the applicable Terms every time you use our Site so that
              you understand which Terms apply. You will be subject to, and will
              be deemed to have been made aware of and to have accepted, the
              changes in any revised Terms of Use by your continued use of the
              Site after the date such revised Terms of Use are posted.
            </Text>
            <Text mt={4}>
              The information provided on the Site is not intended for
              distribution to or use by any person or entity in any jurisdiction
              or country where such distribution or use would be contrary to law
              or regulation or which would subject us to any registration
              requirement within such jurisdiction or country. Accordingly,
              those persons who choose to access the Site from other locations
              do so on their own initiative and are solely responsible for
              compliance with local laws, if and to the extent local laws are
              applicable.
            </Text>
            <Text mt={4}>
              The Site is not tailored to comply with industry-specific
              regulations (Health Insurance Portability and Accountability Act
              (HIPAA), Federal Information Security Management Act (FISMA),
              etc.), so if your interactions would be subjected to such laws,
              you may not use this Site. You may not use the Site in a way that
              would violate the Gramm-Leach-Bliley Act (GLBA).
            </Text>
            <Text mt={4}>
              The Site is intended for users who are at least 18 years old.
              Persons under the age of 18 are not permitted to use or register
              for the Site.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">2. INTELLECTUAL PROPERTY RIGHTS</Text>
            <Text mt={4}>
              Unless otherwise indicated, the Site is our proprietary property
              and all source code, databases, functionality, software, website
              designs, audio, video, text, photographs, and graphics on the Site
              (collectively, the “Content”) and the trademarks, service marks,
              and logos contained therein (the “Marks”) are owned or controlled
              by us or licensed to us, and are protected by copyright and
              trademark laws and various other intellectual property rights and
              unfair competition laws of the United States, international
              copyright laws, and international conventions. The Content and the
              Marks are provided on the Site “AS IS” for your information and
              personal use only. Except as expressly provided in these Terms of
              Use, no part of the Site and no Content or Marks may be copied,
              reproduced, aggregated, republished, uploaded, posted, publicly
              displayed, encoded, translated, transmitted, distributed, sold,
              licensed, or otherwise exploited for any commercial purpose
              whatsoever, without our express prior written permission.
            </Text>
            <Text mt={4}>
              Provided that you are eligible to use the Site, you are granted a
              limited license to access and use the Site and to download or
              print a copy of any portion of the Content to which you have
              properly gained access solely for your personal, non-commercial
              use. We reserve all rights not expressly granted to you in and to
              the Site, the Content and the Marks.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">3. USER REPRESENTATIONS</Text>
            <Text mt={4}>
              By using the Site, you represent and warrant that: (1) all
              registration information you submit will be true, accurate,
              current, and complete; (2) you will maintain the accuracy of such
              information and promptly update such registration information as
              necessary; (3) you have the legal capacity and you agree to comply
              with these Terms of Use; (4) you are not a minor in the
              jurisdiction in which you reside; (5) you will not access the Site
              through automated or non-human means, whether through a bot,
              script or otherwise; (6) you will not use the Site for any illegal
              or unauthorized purpose; and (7) your use of the Site will not
              violate any applicable law or regulation.
            </Text>
            <Text mt={4}>
              If you provide any information that is untrue, inaccurate, not
              current, or incomplete, we have the right to suspend or terminate
              your account and refuse any and all current or future use of the
              Site (or any portion thereof).
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">4. USER REGISTRATION   </Text>
            <Text mt={4}>
              You may be required to register with the Site. You agree to keep
              your password confidential and will be responsible for all use of
              your account and password. We reserve the right to remove,
              reclaim, or change a username you select if we determine, in our
              sole discretion, that such username is inappropriate, obscene, or
              otherwise objectionable.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">5. PRODUCTS</Text>

            <Text mt={4}>
              All products are subject to availability. We reserve the right to
              discontinue any products at any time for any reason. Prices for
              all products are subject to change.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">6. PURCHASES AND PAYMENT</Text>
            <Text mt={4}>We accept the following forms of payment:</Text>
            <UnorderedList mt={4}>
              <ListItem>Visa</ListItem>
              <ListItem>Mastercard</ListItem>
              <ListItem>American Express</ListItem>
              <ListItem>Discover</ListItem>
            </UnorderedList>
            <Text mt={4}>
              You agree to provide current, complete, and accurate purchase and
              account information for all purchases made via the Site. You
              further agree to promptly update account and payment information,
              including email address, payment method, and payment card
              expiration date, so that we can complete your transactions and
              contact you as needed. Sales tax will be added to the price of
              purchases as deemed required by us. We may change prices at any
              time. All payments shall be in GBP, Euros, U.S. Dollars.
            </Text>
            <Text mt={4}>
              You agree to pay all charges at the prices then in effect for your
              purchases and any applicable shipping fees, and you authorize us
              to charge your chosen payment provider for any such amounts upon
              placing your order. We reserve the right to correct any errors or
              mistakes in pricing, even if we have already requested or received
              payment.
            </Text>
            <Text mt={4}>
              We reserve the right to refuse any order placed through the Site.
              We may, in our sole discretion, limit or cancel quantities
              purchased per person, per household, or per order. These
              restrictions may include orders placed by or under the same
              customer account, the same payment method, and/or orders that use
              the same billing or shipping address. We reserve the right to
              limit or prohibit orders that, in our sole judgment, appear to be
              placed by dealers, resellers, or distributors.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">7. REFUNDS POLICY </Text>
            <Text mt={4}>
              All sales are final and no refund will be issued.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">8. PROHIBITED ACTIVITIES</Text>
            <Text mt={4}>
              We have implemented appropriate technical and organizational You
              may not access or use the Site for any purpose other than that for
              which we make the Site available. The Site may not be used in
              connection with any commercial endeavors except those that are
              specifically endorsed or approved by us.
            </Text>
            <Text mt={4}>As a user of the Site, you agree not to:</Text>
            <UnorderedList mt={4}>
              <ListItem>
                Systematically retrieve data or other content from the Site to
                create or compile, directly or indirectly, a collection,
                compilation, database, or directory without written permission
                from us.
              </ListItem>
              <ListItem>
                Trick, defraud, or mislead us and other users, especially in any
                attempt to learn sensitive account information such as user
                passwords.
              </ListItem>
              <ListItem>
                Circumvent, disable, or otherwise interfere with
                security-related features of the Site, including features that
                prevent or restrict the use or copying of any Content or enforce
                limitations on the use of the Site and/or the Content contained
                therein.
              </ListItem>
              <ListItem>
                Disparage, tarnish, or otherwise harm, in our opinion, us and/or
                the Site.
              </ListItem>
              <ListItem>
                Use any information obtained from the Site in order to harass,
                abuse, or harm another person.
              </ListItem>
              <ListItem>
                Make improper use of our support services or submit false
                reports of abuse or misconduct.
              </ListItem>
              <ListItem>
                Use the Site in a manner inconsistent with any applicable laws
                or regulations.
              </ListItem>
              <ListItem>
                Engage in unauthorized framing of or linking to the Site.
              </ListItem>
              <ListItem>
                Upload or transmit (or attempt to upload or to transmit)
                viruses, Trojan horses, or other material, including excessive
                use of capital letters and spamming (continuous posting of
                repetitive text), that interferes with any party’s uninterrupted
                use and enjoyment of the Site or modifies, impairs, disrupts,
                alters, or interferes with the use, features, functions,
                operation, or maintenance of the Site.
              </ListItem>
              <ListItem>
                Engage in any automated use of the system, such as using scripts
                to send comments or messages, or using any data mining, robots,
                or similar data gathering and extraction tools.
              </ListItem>
              <ListItem>
                Delete the copyright or other proprietary rights notice from any
                Content.
              </ListItem>
              <ListItem>
                Attempt to impersonate another user or person or use the
                username of another user.
              </ListItem>
              <ListItem>
                Upload or transmit (or attempt to upload or to transmit) any
                material that acts as a passive or active information collection
                or transmission mechanism, including without limitation, clear
                graphics interchange formats (“gifs”), 1×1 pixels, web bugs,
                cookies, or other similar devices (sometimes referred to as
                “spyware” or “passive collection mechanisms” or “pcms”).
              </ListItem>
              <ListItem>
                Interfere with, disrupt, or create an undue burden on the Site
                or the networks or services connected to the Site.
              </ListItem>
              <ListItem>
                Harass, annoy, intimidate, or threaten any of our employees or
                agents engaged in providing any portion of the Site to you.
              </ListItem>
              <ListItem>
                Attempt to bypass any measures of the Site designed to prevent
                or restrict access to the Site, or any portion of the Site.
              </ListItem>
              <ListItem>
                Copy or adapt the Site’s software, including but not limited to
                Flash, PHP, HTML, JavaScript, or other code.
              </ListItem>
              <ListItem>
                Except as permitted by applicable law, decipher, decompile,
                disassemble, or reverse engineer any of the software comprising
                or in any way making up a part of the Site.
              </ListItem>
              <ListItem>
                Except as may be the result of standard search engine or
                Internet browser usage, use, launch, develop, or distribute any
                automated system, including without limitation, any spider,
                robot, cheat utility, scraper, or offline reader that accesses
                the Site, or using or launching any unauthorized script or other
                software.
              </ListItem>
              <ListItem>
                Use a buying agent or purchasing agent to make purchases on the
                Site.
              </ListItem>
              <ListItem>
                Make any unauthorized use of the Site, including collecting
                usernames and/or email addresses of users by electronic or other
                means for the purpose of sending unsolicited email, or creating
                user accounts by automated means or under false pretenses.
              </ListItem>
              <ListItem>
                Use the Site as part of any effort to compete with us or
                otherwise use the Site and/or the Content for any
                revenue-generating endeavor or commercial enterprise.
              </ListItem>
            </UnorderedList>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">9. USER GENERATED CONTRIBUTIONS</Text>
            <Text mt={4}>
              The Site does not offer users to submit or post content. We may
              provide you with the opportunity to create, submit, post, display,
              transmit, perform, publish, distribute, or broadcast content and
              materials to us or on the Site, including but not limited to text,
              writings, video, audio, photographs, graphics, comments,
              suggestions, or personal information or other material
              (collectively, "Contributions"). Contributions may be viewable by
              other users of the Site and through third-party websites. As such,
              any Contributions you transmit may be treated in accordance with
              the Site Privacy Policy. When you create or make available any
              Contributions, you thereby represent and warrant that:
            </Text>
            <UnorderedList mt={4}>
              <ListItem>
                The creation, distribution, transmission, public display, or
                performance, and the accessing, downloading, or copying of your
                Contributions do not and will not infringe the proprietary
                rights, including but not limited to the copyright, patent,
                trademark, trade secret, or moral rights of any third party.
              </ListItem>
              <ListItem>
                You are the creator and owner of or have the necessary licenses,
                rights, consents, releases, and permissions to use and to
                authorize us, the Site, and other users of the Site to use your
                Contributions in any manner contemplated by the Site and these
                Terms of Use.
              </ListItem>
              <ListItem>
                You have the written consent, release, and/or permission of each
                and every identifiable individual person in your Contributions
                to use the name or likeness of each and every such identifiable
                individual person to enable inclusion and use of your
                Contributions in any manner contemplated by the Site and these
                Terms of Use.
              </ListItem>
              <ListItem>
                Your Contributions are not false, inaccurate, or misleading.
              </ListItem>
              <ListItem>
                Your Contributions are not unsolicited or unauthorized
                advertising, promotional materials, pyramid schemes, chain
                letters, spam, mass mailings, or other forms of solicitation.
              </ListItem>
              <ListItem>
                Your Contributions are not obscene, lewd, lascivious, filthy,
                violent, harassing, libelous, slanderous, or otherwise
                objectionable (as determined by us).
              </ListItem>
              <ListItem>
                Your Contributions do not ridicule, mock, disparage, intimidate,
                or abuse anyone.
              </ListItem>
              <ListItem>
                Your Contributions are not used to harass or threaten (in the
                legal sense of those terms) any other person and to promote
                violence against a specific person or class of people.
              </ListItem>
              <ListItem>
                Your Contributions do not violate any applicable law,
                regulation, or rule.
              </ListItem>
              <ListItem>
                Your Contributions do not violate the privacy or publicity
                rights of any third party.
              </ListItem>
              <ListItem>
                Your Contributions do not violate any applicable law concerning
                child pornography, or otherwise intended to protect the health
                or well-being of minors;
              </ListItem>
              <ListItem>
                Your Contributions do not include any offensive comments that
                are connected to race, national origin, gender, sexual
                preference, or physical handicap.
              </ListItem>
              <ListItem>
                Your Contributions do not otherwise violate, or link to material
                that violates, any provision of these Terms of Use, or any
                applicable law or regulation.
              </ListItem>
            </UnorderedList>
            <Text mt={4}>
              Any use of the Site or the Marketplace Offerings in violation of
              the foregoing violates these Terms of Use and may result in, among
              other things, termination or suspension of your rights to use the
              Site and the Marketplace Offerings.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">10. CONTRIBUTION LICENSE</Text>
            <Text mt={4}>
              You and Site agree that we may access, store, process, and use any
              information and personal data that you provide following the terms
              of the Privacy Policy and your choices (including settings).
            </Text>
            <Text mt={4}>
              By submitting suggestions or other feedback regarding the Site,
              you agree that we can use and share such feedback for any purpose
              without compensation to you.
            </Text>
            <Text mt={4}>
              We do not assert any ownership over your Contributions. You retain
              full ownership of all of your Contributions and any intellectual
              property rights or other proprietary rights associated with your
              Contributions. We are not liable for any statements or
              representations in your Contributions provided by you in any area
              on the Site. You are solely responsible for your Contributions to
              the Site and you expressly agree to exonerate us from any and all
              responsibility and to refrain from any legal action against us
              regarding your Contributions.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">11. SUBMISSIONS</Text>
            <Text mt={4}>
              You acknowledge and agree that any questions, comments,
              suggestions, ideas, feedback, or other information regarding the
              Site or the Marketplace Offerings ("Submissions") provided by you
              to us are non-confidential and shall become our sole property. We
              shall own exclusive rights, including all intellectual property
              rights, and shall be entitled to the unrestricted use and
              dissemination of these Submissions for any lawful purpose,
              commercial or otherwise, without acknowledgment or compensation to
              you. You hereby waive all moral rights to any such Submissions,
              and you hereby warrant that any such Submissions are original with
              you or that you have the right to submit such Submissions. You
              agree there shall be no recourse against us for any alleged or
              actual infringement or misappropriation of any proprietary right
              in your Submissions.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">12. THIRD-PARTY WEBSITES AND CONTENT</Text>

            <Text mt={4}>
              The Site may contain (or you may be sent via the Site or the
              Marketplace Offerings) links to other websites
              ("Third-Party Websites") as well as articles, photographs, text,
              graphics, pictures, designs, music, sound, video, information,
              applications, software, and other content or items belonging to or
              originating from third parties ("Third-Party Content").
              Such Third-Party Websites and Third-Party Content are not
              investigated, monitored, or checked for accuracy, appropriateness,
              or completeness by us, and we are not responsible for any Third
              Party Websites accessed through the Site or
              any Third-Party Content posted on, available through, or installed
              from the Site, including the content, accuracy, offensiveness,
              opinions, reliability, privacy practices, or other policies of or
              contained in the Third-Party Websites or the Third-Party Content.
              Inclusion of, linking to, or permitting the use or installation of
              any Third-Party Websites or any Third-PartyContent does not imply
              approval or endorsement thereof by us. If you decide to leave the
              Site and access the Third-Party Websites or to use or install
              any Third-Party Content, you do so at your own risk, and you
              should be aware these Terms of Use no longer govern. You should
              review the applicable terms and policies, including privacy and
              data gathering practices, of any website to which you navigate
              from the Site or relating to any applications you use or install
              from the Site. Any purchases you make through Third-Party Websites
              will be through other websites and from other companies, and we
              take no responsibility whatsoever in relation to such purchases
              which are exclusively between you and the applicable third party.
              You agree and acknowledge that we do not endorse the products or
              services offered on Third-Party Websites and you shall hold us
              harmless from any harm caused by your purchase of such products or
              services. Additionally, you shall hold us harmless from any losses
              sustained by you or harm caused to you relating to or resulting in
              any way from any Third-Party Content or any contact
              with Third-Party Websites.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">13. ADVERTISERS</Text>
            <Text mt={4}>
              We allow advertisers to display their advertisements and other
              information in certain areas of the Site, such as sidebar
              advertisements or banner advertisements. If you are an advertiser,
              you shall take full responsibility for any advertisements you
              place on the Site and any services provided on the Site or
              products sold through those advertisements. Further, as an
              advertiser, you warrant and represent that you possess all rights
              and authority to place advertisements on the Site, including, but
              not limited to, intellectual property rights, publicity rights,
              and contractual rights. We simply provide the space to place such
              advertisements, and we have no other relationship with
              advertisers.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">14. SITE MANAGEMENT</Text>
            <Text mt={4}>
              We reserve the right, but not the obligation, to: (1) monitor the
              Site for violations of these Terms of Use; (2) take appropriate
              legal action against anyone who, in our sole discretion, violates
              the law or these Terms of Use, including without limitation,
              reporting such user to law enforcement authorities; (3) in our
              sole discretion and without limitation, refuse, restrict access
              to, limit the availability of, or disable (to the extent
              technologically feasible) any of your Contributions or any portion
              thereof; (4) in our sole discretion and without limitation,
              notice, or liability, to remove from the Site or otherwise disable
              all files and content that are excessive in size or are in any way
              burdensome to our systems; and (5) otherwise manage the Site in a
              manner designed to protect our rights and property and to
              facilitate the proper functioning of the Site and the Marketplace
              Offerings.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">15. PRIVACY POLICY</Text>
            <Text mt={4}>
              We care about data privacy and security. Please review our Privacy
              Policy:{' '}
              <a
                style={{color: 'blue', textDecoration: 'underline'}}
                href="http://www.showpiece.com/privacy-policy"
                target="_blank"
                rel="noreferrer"
              >
                 http://www.showpiece.com/privacy-policy
              </a>
              . By using the Site or the Marketplace Offerings, you agree to be
              bound by our Privacy Policy, which is incorporated into these
              Terms of Use. Please be advised the Site and the Marketplace
              Offerings are hosted in the United Kingdom. If you access the Site
              or the Marketplace Offerings from any other region of the world
              with laws or other requirements governing personal data
              collection, use, or disclosure that differ from applicable laws
              in the United Kingdom, then through your continued use of the
              Site, you are transferring your data to the United Kingdom, and
              you expressly consent to have your data transferred to and
              processed in the United Kingdom.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">16. TERM AND TERMINATION</Text>
            <Text mt={4}>
              These Terms of Use shall remain in full force and effect while you
              use the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS
              OF USE, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND
              WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE
              AND THE MARKETPLACE OFFERINGS (INCLUDING BLOCKING CERTAIN IP
              ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON,
              INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION,
              WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OF USE OR OF ANY
              APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR
              PARTICIPATION IN THE SITE AND THE MARKETPLACE OFFERINGS OR
              DELETE YOUR ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED
              AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.
            </Text>
            <Text mt={4}>
              If we terminate or suspend your account for any reason, you are
              prohibited from registering and creating a new account under your
              name, a fake or borrowed name, or the name of any third party,
              even if you may be acting on behalf of the third party. In
              addition to terminating or suspending your account, we reserve the
              right to take appropriate legal action, including without
              limitation pursuing civil, criminal, and injunctive redress.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">17. MODIFICATIONS AND INTERRUPTIONS</Text>
            <Text mt={4}>
              We reserve the right to change, modify, or remove the contents of
              the Site at any time or for any reason at our sole discretion
              without notice. However, we have no obligation to update any
              information on our Site. We also reserve the right to modify or
              discontinue all or part of the Marketplace Offerings without
              notice at any time. We will not be liable to you or any third
              party for any modification, price change, suspension, or
              discontinuance of the Site or the Marketplace Offerings.
            </Text>
            <Text mt={4}>
              We cannot guarantee the Site and the Marketplace Offerings will be
              available at all times. We may experience hardware, software, or
              other problems or need to perform maintenance related to the Site,
              resulting in interruptions, delays, or errors. We reserve the
              right to change, revise, update, suspend, discontinue, or
              otherwise modify the Site or the Marketplace Offerings at any time
              or for any reason without notice to you. You agree that we have no
              liability whatsoever for any loss, damage, or inconvenience caused
              by your inability to access or use the Site or the Marketplace
              Offerings during any downtime or discontinuance of the Site or the
              Marketplace Offerings. Nothing in these Terms of Use will be
              construed to obligate us to maintain and support the Site or the
              Marketplace Offerings or to supply any corrections, updates, or
              releases in connection therewith.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">18. GOVERNING LAW</Text>
            <Text mt={4}>
              These conditions are governed by and interpreted following the
              laws of the United Kingdom, and the use of the United Nations
              Convention of Contracts for the International Sales of Goods is
              expressly excluded. If your habitual residence is in the EU, and
              you are a consumer, you additionally possess the protection
              provided to you by obligatory provisions of the law in your
              country to residence. Showpiece Technologies Limited and yourself
              both agree to submit to the non-exclusive jurisdiction of the
              courts of England, which means that you may make a claim to defend
              your consumer protection rights in regards to these Conditions of
              Use in the United Kingdom, or in the EU country in which you
              reside.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">19. DISPUTE RESOLUTION</Text>
            <Text mt={4}>
              The European Commission provides an online dispute resolution
              platform, which you can access
              here: https://ec.europa.eu/consumers/odr. If you would like to
              bring this subject to our attention, please contact us.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">20. CORRECTIONS</Text>
            <Text mt={4}>
              There may be information on the Site that contains typographical
              errors, inaccuracies, or omissions that may relate to the
              Marketplace Offerings, including descriptions, pricing,
              availability, and various other information. We reserve the right
              to correct any errors, inaccuracies, or omissions and to change or
              update the information on the Site at any time, without prior
              notice.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">21. DISCLAIMER</Text>
            <Text mt={4}>
              THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE
              THAT YOUR USE OF THE SITE SERVICES WILL BE AT YOUR SOLE RISK. TO
              THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES,
              EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE
              THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
              NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT
              THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT
              OF ANY WEBSITES LINKED TO THIS SITE AND WE WILL ASSUME NO
              LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR
              INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR
              PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR
              ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR
              USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION
              AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION
              OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS,
              VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR
              THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR
              OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE
              OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED,
              TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT
              WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY
              PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH
              THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE
              APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE
              WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING
              ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF
              PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE
              THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST
              JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">22. LIMITATIONS OF LIABILITY</Text>
            <Text mt={4}>
              IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
              LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
              CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
              DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR
              OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE, EVEN IF WE HAVE
              BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING
              ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU
              FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION,
              WILL AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO
              US . CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW
              LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION
              OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE
              ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY
              HAVE ADDITIONAL RIGHTS.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">23. INDEMNIFICATION</Text>
            <Text mt={4}>
              You agree to defend, indemnify, and hold us harmless, including
              our subsidiaries, affiliates, and all of our respective officers,
              agents, partners, and employees, from and against any loss,
              damage, liability, claim, or demand, including reasonable
              attorneys’ fees and expenses, made by any third party due to or
              arising out of: (1) use of the Site; (2) breach of these Terms of
              Use; (3) any breach of your representations and warranties set
              forth in these Terms of Use; (4) your violation of the rights of a
              third party, including but not limited to intellectual property
              rights; or (5) any overt harmful act toward any other user of the
              Site with whom you connected via the Site. Notwithstanding the
              foregoing, we reserve the right, at your expense, to assume the
              exclusive defense and control of any matter for which you are
              required to indemnify us, and you agree to cooperate, at your
              expense, with our defense of such claims. We will use reasonable
              efforts to notify you of any such claim, action, or proceeding
              which is subject to this indemnification upon becoming aware of
              it.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">24. USER DATA</Text>
            <Text mt={4}>
              We will maintain certain data that you transmit to the Site for
              the purpose of managing the performance of the Site, as well as
              data relating to your use of the Site. Although we perform regular
              routine backups of data, you are solely responsible for all data
              that you transmit or that relates to any activity you have
              undertaken using the Site. You agree that we shall have no
              liability to you for any loss or corruption of any such data, and
              you hereby waive any right of action against us arising from any
              such loss or corruption of such data. it.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">
              25. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
            </Text>
            <Text mt={4}>
              Visiting the Site, sending us emails, and completing online forms
              constitute electronic communications. You consent to receive
              electronic communications, and you agree that all agreements,
              notices, disclosures, and other communications we provide to you
              electronically, via email and on the Site, satisfy any legal
              requirement that such communication be in writing. YOU HEREBY
              AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND
              OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES,
              AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA
              THE SITE. You hereby waive any rights or requirements under any
              statutes, regulations, rules, ordinances, or other laws in any
              jurisdiction which require an original signature or delivery or
              retention of non-electronic records, or to payments or the
              granting of credits by any means other than electronic means.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">26. CALIFORNIA USERS AND RESIDENTS</Text>
            <Text mt={4}>
              If any complaint with us is not satisfactorily resolved, you can
              contact the Complaint Assistance Unit of the Division of Consumer
              Services of the California Department of Consumer Affairs in
              writing at 1625 North Market Blvd., Suite N 112, Sacramento,
              California 95834 or by telephone at (800) 952-5210 or (916)
              445-1254.
            </Text>
          </Box>
          <Box mt={20}>
            <Text id="banksy-vdm-competitions" textStyle="h5">
              27. MISCELLANEOUS
            </Text>
            <Text mt={4}>
              These Terms of Use and any policies or operating rules posted by
              us on the Site or in respect to the Site constitute the entire
              agreement and understanding between you and us. Our failure to
              exercise or enforce any right or provision of these Terms of Use
              shall not operate as a waiver of such right or provision. These
              Terms of Use operate to the fullest extent permissible by law. We
              may assign any or all of our rights and obligations to others at
              any time. We shall not be responsible or liable for any loss,
              damage, delay, or failure to act caused by any cause beyond our
              reasonable control. If any provision or part of a provision of
              these Terms of Use is determined to be unlawful, void, or
              unenforceable, that provision or part of the provision is deemed
              severable from these Terms of Use and does not affect the validity
              and enforceability of any remaining provisions. There is no joint
              venture, partnership, employment or agency relationship created
              between you and us as a result of these Terms of Use or use of the
              Site. You agree that these Terms of Use will not be construed
              against us by virtue of having drafted them. You hereby waive any
              and all defenses you may have based on the electronic form of
              these Terms of Use and the lack of signing by the parties hereto
              to execute these Terms of Use.
            </Text>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">28. BANKSY VDM COMPETITIONS</Text>
            <UnorderedList mt={4}>
              <ListItem>
                This competition is promoted by Showpiece Technology Limited
                (“Showpiece”), 64-66 Glentham Rd, London SW13 9JJ.
              </ListItem>
              <ListItem>
                This promotion is open to collectors based outside of the US and
                countries considered to be high risk including but not limited
                to Russia, Cuba, Iran, North Korea, Syria, and the Crimea,
                Donetsk, and Luhansk Regions.
              </ListItem>
              <ListItem>
                There is no guarantee that users will be able to sell the pieces
                in future via the Showpiece marketplace, at present this is
                supported in a limited number of countries.
              </ListItem>
              <ListItem>
                Employees of Showpiece, their parents, subsidiaries and
                affiliated companies and their immediate families are unable to
                enter the competition.
              </ListItem>
              <ListItem>
                You must be at least 18 years of age to enter this competition.
              </ListItem>
              <ListItem>
                By entering your details you may be eligible for entry into two
                competitions; referral and cancelled viewer.
              </ListItem>
              <ListItem>
                How to enter:{' '}
                <strong>
                  Share the Banksy Waitlist after you have signed up
                </strong>
                .
              </ListItem>
              <ListItem>
                The opening date for entries is <strong>04/08/2023</strong>. The
                closing date for entries is <strong>21/08/2023</strong>. No
                entries received after this date will be accepted.
              </ListItem>
              <ListItem>No purchase necessary.</ListItem>
              <ListItem>Only one entry is allowed per user.</ListItem>
              <ListItem>
                1 Prize of 5 x £100 fractions of{' '}
                <strong>Banksy’s Valentine’s Day Mascara fraction</strong>.
              </ListItem>
              <ListItem>
                <strong>One winner will be selected</strong>.
              </ListItem>
              <ListItem>
                Those entering the promotional code ‘cancelled’ when submitting
                their details before midnight on 4/8/23 will be entered into the
                ‘cancelled viewer’ prize draw to win £1000 worth of fractions.
              </ListItem>
              <ListItem>No cash or prize alternatives are available.</ListItem>
              <ListItem>
                Showpiece reserve the right in their reasonable discretion to
                substitute any prize with a prize of equal or greater value.
              </ListItem>
              <ListItem>
                The winner of both competitions will be drawn at random from all
                correct entries by an electronic system and notified via Email
                no later than <strong>31/08/2023</strong>. Where we require
                details from you, if you do not provide these within 28 days of
                notification we reserve the right to select a different winner.
              </ListItem>
              <ListItem>
                All entrants are expected to act fairly and in the good spirit
                of the competition. Showpiece reserves the right to investigate
                any irregularities and disqualify entrants at its absolute
                discretion.
              </ListItem>
              <ListItem>
                The prize will be delivered to the winner between 01/09/2023 –
                30/09/2023. Showpiece reserves the right to select another
                winner if the original winner cannot be contacted within a
                reasonable timeframe.
              </ListItem>
              <ListItem>
                Any application containing incorrect, false or unreadable
                information will be rejected. Any applications made on behalf of
                or for another person or multiple entries will not be included
                in the competition.
              </ListItem>
              <ListItem>
                Showpiece’s decision as to who has won the competition shall be
                final.
              </ListItem>
              <ListItem>
                The entry instructions are part of the Terms and Conditions for
                this competition.
              </ListItem>
              <ListItem>
                By entering the competition you are agreeing to accept these
                Terms and Conditions. Any breach of these Terms and Conditions
                by you will mean that your entry will not be valid, and you will
                not be allowed to enter this competition.
              </ListItem>
              <ListItem>
                By entering this competition you are agreeing that, if you win,
                your name and entry may be a) used for the purpose of announcing
                the winner and/or distributed to individuals who request details
                of the winner and/or b) in any related publicity by Showpiece,
                without additional payment or permission.
              </ListItem>
              <ListItem>
                Any personal information you give us will be used in accordance
                with the Showpiece privacy policy which can be found at:{' '}
                <a
                  style={{color: 'blue', textDecoration: 'underline'}}
                  href="http://www.showpiece.com/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  http://www.showpiece.com/privacy-policy
                </a>
                .
              </ListItem>
              <ListItem>
                Under no circumstances will Showpiece be responsible for any
                loss, damages, costs or expenses arising from or in any way
                connected with any errors, defects, interruptions, malfunctions
                or delays in the promotion of the competition or prize.
              </ListItem>
              <ListItem>
                Showpiece will not be responsible unless required by law, for
                any loss, changes, costs or expenses, which may arise in
                connection with this competition and Showpiece can cancel or
                alter the competition at any stage.
              </ListItem>
              <ListItem>
                Any dispute relating to the competition shall be governed by the
                laws of England and Wales and will be subject to the exclusive
                jurisdiction of the English courts.
              </ListItem>
            </UnorderedList>
          </Box>
          <Box mt={20}>
            <Text textStyle="h5">29. CONTACT US</Text>
            <Text mt={4}>
              In order to resolve a complaint regarding the Site or to receive
              further information regarding use of the Site, please contact us
              at:
            </Text>
            <Text mt={4}>
              Showpiece Technologies Limited
              <br /> 64-66 Glentham Road <br />
              Barnes, London SW13 9JJ <br />
              United Kingdom <br />
              <a style={{color: 'blue'}} href="mailto:info@showpiece.com">
                info@showpiece.com.
              </a>
            </Text>
          </Box>
        </Box>
      </Container>
    </PageLayout>
  );
};

export default PrivacyPolicy;
